import React, { useState } from "react"
import {
  InputReason,
  OrderAddressesModificationType,
  OrderModificationAddresses
} from "lib/types/generated/graphql-types"
import { useMutation } from "@apollo/client"
import { handleErrorMessages } from "helpers/errors"
import Reason from "../ManageOrder/Reason/Reason"
import UPDATE_ADDRESS_MODIFICATION
  from "../../../graphql/mutations/order/modification/address/UpdateModificationAddresses"
import { ReasonType } from "lib/types/order"
import { isSkipReason } from "../helpers"

type Props = {
  modification: OrderModificationAddresses
  refetch: () => void
  orderLoading: boolean
}

const ModificationAddressReason = ({ modification, refetch, orderLoading }: Props) => {
  const [reasonType, setReasonType] = useState<ReasonType | undefined>()
  const [updateModification, { loading }] = useMutation(UPDATE_ADDRESS_MODIFICATION, {
    onCompleted: () => refetch(),
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const addReason = (reason: InputReason) => {
    updateModification({
      variables: {
        modificationId: modification.id,
        input: {
          addresses: {
            data: JSON.stringify(modification.addresses.data),
            modificationType: OrderAddressesModificationType.Update
          },
          ...(reason.cause && reason.code && !isSkipReason(reasonType) && { reason: reason })
        }
      }
    })
  }

  const removeReason = () => {
    updateModification({
      variables: {
        modificationId: modification.id,
        input: {
          addresses: {
            data: JSON.stringify(modification.addresses.data),
            modificationType: OrderAddressesModificationType.Update
          },
          reason: null
        }
      }
    })
  }
  return (
    <Reason
      addReason={addReason}
      removeReason={removeReason}
      reasonType={reasonType}
      setReasonType={setReasonType}
      orderReason={modification.reason}
      loading={loading}
      orderLoading={orderLoading}
    />
  )
}

export default ModificationAddressReason
